module.exports = __webpack_public_path__ + "media/images/app/products/index/categories/necklace-2af7ed1df18cac658db65645014537cc.webp";